import { useBlocker } from 'react-router-dom'

import ConfirmationDialog from '~/components/confirmationDialog'

type TProps = {
  shouldDisplayWarning: boolean
}
function WarnUnsavedChangesInsideApp({ shouldDisplayWarning }: TProps) {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      shouldDisplayWarning &&
      currentLocation.pathname !== nextLocation.pathname,
  )

  return blocker.state === 'blocked' ? (
    <ConfirmationDialog
      title="Are you sure you want to leave this page?"
      textContent="Changes you made may not be saved."
      open
      handleCancel={() => blocker.reset()}
      handleConfirm={() => blocker.proceed()}
      isWarning
    />
  ) : null
}

export default WarnUnsavedChangesInsideApp
